import * as React from 'react';

const SvgComponent = _props => {
  const {'aria-label': ariaLabel, role, alt, ...rest} = _props;
  const props = {
    ...rest,
    ...(ariaLabel || alt
      ? {
          role: role || 'img',
          'aria-label': ariaLabel,
          alt
        }
      : {
          'aria-hidden': 'true'
        })
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path fill="none" d="M0 .002h24v24H0z" />
      <path
        d="M21.292 7.949l1.415-1.414a.999.999 0 000-1.414L22 4.414l.707-.708-1.414-1.414-.707.708-.707-.707a.999.999 0 00-1.414 0L17.05 3.707l-1.414-1.414a.999.999 0 00-1.414 0l-3.536 3.535a.997.997 0 000 1.415l2.829 2.827-4.243 4.244-2.828-2.828a1.03 1.03 0 00-1.414 0l-3.536 3.536a.999.999 0 000 1.414l1.414 1.414-1.414 1.414a1 1 0 000 1.414l.707.707-.707.708 1.414 1.414.707-.708.708.708a1 1 0 001.414 0l1.414-1.414 1.414 1.414a1 1 0 001.414 0l3.536-3.536a.997.997 0 000-1.414l-2.829-2.83 4.243-4.242 2.828 2.828a1 1 0 001.414 0l3.536-3.536a1 1 0 000-1.413l-1.415-1.415zm-2.12-3.535l1.414 1.414-.707.707-1.414-1.414.707-.707zM5.03 21.385l-1.415-1.414.707-.707 1.415 1.414-.707.707zm4.242 0l-5.657-5.656 2.122-2.122 5.657 5.657-2.122 2.121zm9.192-9.193l-5.657-5.657 2.122-2.121 5.657 5.657-2.122 2.121z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgComponent;
